import React, {Component} from 'react';
import {connect} from 'react-redux';
import NewSolicitorForm from '../components/newSolicitorForm';
import {
    changeNewSolFormSettings,
    changeNewSolicitorLawsysField,
    changeNewSolicitorProperties,
    requestGetSelectedSolicitorUser,
    requestNewSolicitor,
    requestPatchExistingSolicitor,
    requestSendResetPasswordEmailToSolicitor,
    solicitorFormEmailInfo,
    solicitorFormEmailValidationError,
    solicitorFormUsernameInfo,
    solicitorFormUsernameValidationError,
    unlockSolicitorUser,
    changeSolicitorUserCaseAndSubCasesTypes,
} from "../actions/newSolicitor";
import { goBack } from 'connected-react-router'
import {requestLawsysFirmsFiltered, changeLawsysFirmState} from "../actions/lawsysFirms";
import _ from 'lodash';
import {
    requestGetSolicitorGroups,
    requestGetSpecificSolicitorGroupEdit
} from "../actions/solicitorGroup";
import {patchSolicitorGroup} from "../actions/groups";
import {isEmail, isPhone} from "../helpers/functions";
import {
    handleADcaseTypes,
    handleADSubCaseTypes,
    getAdCaseSubExpenseTypeDtos
} from "../helpers/advanceDisbursments/advanceDisbursements";

class NewSolicitorFormHOC extends Component {
    componentWillMount() {
        if (this.props.router.location.pathname.includes('/solicitors/edit-solicitor')) {
            let route = this.props.router.location.pathname;
            let splitedRoute = _.split(route, '/', 4);
            this.props.requestGetSelectedSolicitorUser(splitedRoute[3])
        }
    }

    componentDidUpdate(prevProps, prevState) {
        clearTimeout(this.askServer);
        if (this.props.newSolicitor.shouldRenderGroupSelect && !prevProps.newSolicitor.shouldRenderGroupSelect) {
            this.props.requesteGetSolicitorGroups();
        }
        if (this.props.newSolicitor.newSolicitorFormData.solicitorGroupId > 0
            && this.props.newSolicitor.newSolicitorFormData.solicitorGroupId !== prevProps.newSolicitor.newSolicitorFormData.solicitorGroupId)
        {
            this.props.requestGetSpecificSolicitorGroupEdit(this.props.newSolicitor.newSolicitorFormData.solicitorGroupId)
        }
        if(this.props.lawsysFirms.suggestionFieldValue !== prevProps.lawsysFirms.suggestionFieldValue 
            && this.props.lawsysFirms.suggestionFieldValue.length >= 3)
        {
            this.askServer = setTimeout(() => {
                this.props.requestLawsysFirmsFiltered( {
                    search:  this.props.lawsysFirms.suggestionFieldValue,
                })
            }, 500);
        }
    }

    setGroupOfSolicitor = () => {
        let selectedGroup = _.find(this.props.newSolicitor.solicitorGroups, item => {
            return item.id.toString() === this.props.newSolicitor.selectedGroup
        });
        if (selectedGroup) {
            let updatedGroup = {
                id: selectedGroup.id,
                solicitors: [
                    ...selectedGroup.solicitors,
                    {
                        lawsysFirmId: parseInt(this.props.newSolicitor.newSolicitorFormData.lawsysAgentId)
                    }
                ]
            };
            this.props.patchSolicitorGroup(updatedGroup.id, updatedGroup);
        }
    };

    //changes the advanced disbursements form checkboxes
    _handleAdvancedDisbursementsCheckBoxes = (evt) => {
        this.props.changeSolicitorUserCaseAndSubCasesTypes({key: evt.target.name, value: evt.target.checked});
    };


    _handleAdvancedDisbursementsMultipleCaseTypes = (key, value) => {

        let selectedCaseTypes = [...this.props.newSolicitor.newSolicitorFormData.selectedCaseTypes];
        let checkedCaseTypesIds = [...this.props.newSolicitor.newSolicitorFormData.checkedCaseTypesIds];
        let propsCases = {
            value: value,
            selectedCaseTypes: selectedCaseTypes,
            checkedCaseTypesIds: checkedCaseTypesIds,
            caseTypes: [...this.props.caseTypes.cases],
            selectedCaseTypeIndex: null,
            changeAdvancedDisbursementsFormData: this.props.changeSolicitorUserCaseAndSubCasesTypes,
            expenseTypes: [],
            solicitorGroup: null
        };

        handleADcaseTypes(propsCases);

    }

    //function than handles the checked state of cases
    _handleAdvancedDisbursementsCheckedCaseTypes = (questionId, group) => {
        let selectedCaseTypesIds = [...this.props.newSolicitor.newSolicitorFormData.checkedCaseTypesIds];
        if (selectedCaseTypesIds.includes(questionId))
            return true;
        else return false
    };
    //function than handles the checked state of sub cases
    _handleAdCheckedSubCaseTypes = (subCaseTypeId, group) => {
        let checkedSubCaseTypesIds = [...this.props.newSolicitor.newSolicitorFormData.checkedSubCaseTypesIds];
        if (checkedSubCaseTypesIds.includes(subCaseTypeId))
            return true;
        else return false
    };

    //for advanced disbursements
    _getSubCasesBasedOnSelectedCasesAd = () => {

        let checkedCaseTypesIds = [...this.props.newSolicitor.newSolicitorFormData.checkedCaseTypesIds];
        let subCaseTypes = [...this.props.caseTypes.subCases];
        if (subCaseTypes.length > 0) {
            subCaseTypes = subCaseTypes.filter(i => this.props.solicitorGroup.advancedDisbursementsFormData.checkedSubCaseTypesIds.includes(i.id))
        }
        let featuredSubCases = [];
        _.forEach(checkedCaseTypesIds, (caseTypeId) => {
            featuredSubCases = [...featuredSubCases, ..._.filter(subCaseTypes, item => {
                return item.caseTypeId === caseTypeId
            })]
        });
        return featuredSubCases;

    };
    //action that handles the multi select list of sub cases
    _handleAdSelectedSubCaseTypes = (key, value) => {
        let selectedSubCaseTypes = [...this.props.newSolicitor.newSolicitorFormData.selectedSubCaseTypes];
        let subCaseTypes = [...this.props.caseTypes.subCases];
        let propsSubCases = {
            value: value,
            selectedSubCaseTypeIndex: null,
            selectedSubCaseTypes: selectedSubCaseTypes,
            checkedSubCaseTypesIds: [...this.props.newSolicitor.newSolicitorFormData.checkedSubCaseTypesIds],
            subCaseTypes: subCaseTypes,
            changeAdvancedDisbursementsFormData: this.props.changeSolicitorUserCaseAndSubCasesTypes
        }
        handleADSubCaseTypes(propsSubCases);
    };


    handleSubmit = (evt) => {
        evt.preventDefault();
        if (this.props.newSolicitor.shouldRenderGroupSelect) {
            return false;
        }
        let valid = true;
        let formData = this.props.newSolicitor.newSolicitorFormData;

        if (!isPhone(formData.telephoneNumber1) && (formData.telephoneNumber1 !== '')) {
            valid = false;
            this.props.changeNewSolFormSettings('notValidTel1', 'Telephone number is not valid.')
        }
        if (!isPhone(formData.telephoneNumber2) && (formData.telephoneNumber2 !== '')) {
            valid = false;
            this.props.changeNewSolFormSettings('notValidTel2', 'Telephone number is not valid.')

        }
        if (!isEmail(formData.solicitorsEmailAddress)) {
            valid = false;
            this.props.changeNewSolFormSettings('notValidEmail', 'Email is not valid.')

        }
        if (!isEmail(formData.ccEmailAddress) && (formData.ccEmailAddress !== '')) {
            valid = false;
            this.props.changeNewSolFormSettings('notValidEmailCC', 'Email is not valid.')
        }
        if (formData.lawsysAgentId === undefined || formData.lawsysAgentId === '') {
            valid = false;
            this.props.changeNewSolFormSettings('notValidSolicitor', 'Select a solicitor from the dropdown')
        }
        if (valid) {
            if (this.props.router.location.pathname === '/solicitors/add-solicitor')
                this.props.addNewSolicitor(formData, this.props.user.loggedInUser.token);
            else {
                let sendBody = {
                    userId: this.props.newSolicitor.selectedUserId,
                    lawsysId: formData.lawsysAgentId,
                    solicitorGroupId: formData.solicitorGroupId,
                    lawsysName: formData.lawsysAgentName,
                    forename: formData.forename,
                    surname: formData.surname,
                    ccEmail: formData.ccEmailAddress,
                    userName: formData.userName,
                    addressLine1: formData.addressLine1,
                    addressLine2: formData.addressLine2,
                    city: formData.city,
                    postcode: formData.postcode,
                    country: formData.country,
                    telephone1: formData.telephoneNumber1,
                    telephone1Description: formData.telephoneNumber1Description,
                    telephone2: formData.telephoneNumber2,
                    telephone2Description: formData.telephoneNumber2Description,
                    allowedToCreateApplications: formData.allowedToCreateApplications,
                    email: formData.solicitorsEmailAddress,
                    role: 'Solicitor',
                    allowedToSeeAllFirmApplications: formData.allowedToSeeAllFirmApplications,
                    disbursementsAllowed: this.props.newSolicitor.newSolicitorFormData.advancedDisbursementsChecked,
                    disbursementsCaseSubCaseTypeDtos: getAdCaseSubExpenseTypeDtos(this.props.newSolicitor, this.props.caseTypes)

                };
                this.props.requestPatchExistingSolicitor(sendBody, this.props.newSolicitor.selectedUserId)
            }
        }
    };

    onUnlockUser = () => {
        this.props.unlockSolicitorUser({
            solicitorUserId: this.props.newSolicitor.selectedUserId
        })
    };

    onSuggestionChange = (value, action) => {
        if (action.action !== 'input-blur' && action.action !== 'menu-close')
        {
            if (value.length < 3)
            {
                this.props.changeLawsysFirmState('lawsysFirmsFiltered', []);
                this.props.changeLawsysFirmState('selectedLawsysFirmsDropdown', []);
                this.props.newSolicitorProperties('solicitorGroupId', '');
                this.props.newSolicitorProperties('solicitorGroupName', '');
                this.props.newSolicitorProperties('lawsysAgentId', '');
                this.props.newSolicitorProperties('lawsysAgentName', '');
                this.props.newSolicitorProperties('addressLine1', '');
                this.props.newSolicitorProperties('postcode', '');
            }
            this.props.changeLawsysFirmState('suggestionFieldValue', value);
        }
    };


    onSuggestionSelected = (value) => {
        let lawsysFirm  = this.props.lawsysFirms.lawsysFirmsFiltered.find(x => x.id === value.value);
        this.props.changeLawsysFirmState('lawsysFirmsFiltered', [lawsysFirm]);
        this.props.changeLawsysFirmState('selectedLawsysFirmsDropdown', [lawsysFirm]);
        this.props.changeLawsysFirmState('selectedLawsysFirms', [lawsysFirm]);
        this.props.changeNewSolFormSettings('notValidSolicitor', '');
        this.props.changeNewSolicitorLawsysField(({lawsysFirms: [lawsysFirm], id: value.value}));
    };

    render() {
        return (
            <NewSolicitorForm
                onUnlockUser={this.onUnlockUser}
                setGroupOfSolicitor={this.setGroupOfSolicitor}
                changeNewSolFormSettings={this.props.changeNewSolFormSettings}
                user={this.props.user}
                goBack={this.props.goBack}
                router={this.props.router}
                HandleSubmit={this.handleSubmit}
                NewSolicitor={this.props.newSolicitor}
                AddNewSolicitor={this.props.addNewSolicitor}
                HandleNewSolicitor={this.props.newSolicitorProperties}
                DisplaySolicitorFormUsernameValidationError={this.props.displaySolicitorFormUsernameValidationError}
                DisplaySolicitorFormEmailValidationError={this.props.displaySolicitorFormEmailValidationError}
                DisplaySolicitorFormUsernameInfo={this.props.displaySolicitorFormUsernameInfo}
                DisplaySolicitorFormEmailInfo={this.props.displaySolicitorFormEmailInfo}
                lawsysFirms={this.props.lawsysFirms}
                changeNewSolicitorLawsysField={this.props.changeNewSolicitorLawsysField}
                sendResetPasswordEmail={this.props.sendResetPasswordEmail}
                SolicitorGroup={this.props.solicitorGroup}
                _handleAdvancedDisbursementsCheckBoxes={this._handleAdvancedDisbursementsCheckBoxes}
                _handleAdvancedDisbursementsMultipleCaseTypes={this._handleAdvancedDisbursementsMultipleCaseTypes}
                _handleAdSelectedSubCaseTypes={this._handleAdSelectedSubCaseTypes}
                subCases={this._getSubCasesBasedOnSelectedCasesAd()}
                _handleAdvancedDisbursementsCheckedCaseTypes={this._handleAdvancedDisbursementsCheckedCaseTypes}
                _handleAdCheckedSubCaseTypes={this._handleAdCheckedSubCaseTypes}
                onSuggestionSelected={this.onSuggestionSelected}
                onSuggestionChange={this.onSuggestionChange}
            />
        )
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
        newSolicitor: state.newSolicitor,
        lawsysFirms: state.lawsysFirms,
        router: state.router,
        solicitorGroup: state.solicitorGroup,
        caseTypes: state.caseTypes,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        displaySolicitorFormEmailInfo: () => {
            dispatch(solicitorFormEmailInfo())
        },
        displaySolicitorFormUsernameInfo: () => {
            dispatch(solicitorFormUsernameInfo())
        },
        displaySolicitorFormEmailValidationError: () => {
            dispatch(solicitorFormEmailValidationError())
        },
        displaySolicitorFormUsernameValidationError: () => {
            dispatch(solicitorFormUsernameValidationError())
        },
        newSolicitorProperties: (property, value) => {
            dispatch(changeNewSolicitorProperties(property, value))
        },
        addNewSolicitor: (newSolicitor, token) => {
            dispatch(requestNewSolicitor(newSolicitor, token))
        },
        changeNewSolFormSettings: (key, value) => {
            dispatch(changeNewSolFormSettings(key, value))
        },
        requestPatchExistingSolicitor: (solicitor, id) => {
            dispatch(requestPatchExistingSolicitor(solicitor, id))
        },
        goBack: () => {
            dispatch(goBack())
        },
        changeNewSolicitorLawsysField: (payload) => {
            dispatch(changeNewSolicitorLawsysField(payload))
        },
        requesteGetSolicitorGroups: () => {
            dispatch(requestGetSolicitorGroups())
        },
        requestGetSelectedSolicitorUser: (solicitorId) => {
            dispatch(requestGetSelectedSolicitorUser(solicitorId))
        },
        sendResetPasswordEmail: (payload) => {
            dispatch(requestSendResetPasswordEmailToSolicitor(payload));
        },
        patchSolicitorGroup: (groupId, group) => {
            dispatch(patchSolicitorGroup(groupId, group))
        },
        unlockSolicitorUser: (payload) => {
            dispatch(unlockSolicitorUser(payload))
        },
        requestGetSpecificSolicitorGroupEdit: (id) => {
            dispatch(requestGetSpecificSolicitorGroupEdit(id))
        },
        changeSolicitorUserCaseAndSubCasesTypes: (payload) => {
            dispatch(changeSolicitorUserCaseAndSubCasesTypes(payload))
        },
        changeLawsysFirmState: (key, value) => {
            dispatch(changeLawsysFirmState(key, value))
        },
        requestLawsysFirmsFiltered: (payload) => {
            dispatch(requestLawsysFirmsFiltered(payload))
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(NewSolicitorFormHOC);
